// events
export const UPDATE_EVENTS = 'UPDATE_EVENTS';
export const REMOVE_EVENT = 'REMOVE_EVENT';

// templates
export const UPDATE_CARD_TEMPLATES = 'UPDATE_CARD_TEMPLATES';

// user
export const USER_LOG_IN = 'USER_LOG_IN';
export const USER_LOG_OUT = 'USER_LOG_OUT';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_ADD_ADDRESS = 'USER_ADD_ADDRESS';
export const USER_UPDATE_DETAILS = 'USER_UPDATE_DETAILS';

// sofologist
export const SOFOLOGIST_UPDATE_TOKEN = 'SOFOLOGIST_UPDATE_TOKEN';
export const SOFOLOGIST_LOG_IN_ERRORS = 'SOFOLOGIST_LOG_IN_ERRORS';
export const SOFOLOGIST_LOG_OUT = 'SOFOLOGIST_LOG_OUT';
export const SOFOLOGIST_LOG_IN = 'SOFOLOGIST_LOG_IN';
export const UPDATE_ALL_STORES = 'UPDATE_ALL_STORES';
export const CASH_PAYMENT_CONFIG_LOADED = 'CASH_PAYMENT_CONFIG_LOADED';

// baskets
export const UPDATE_BASKETS = 'UPDATE_BASKETS';
export const CANCELABLE = 'CANCELABLE';
export const CANCEL_ORDER = 'CANCEL_ORDER';


// activity
export const UPDATE_FAVOURITES = 'UPDATE_FAVOURITES';
export const UPDATE_RECENT = 'UPDATE_RECENT';
export const UPDATE_RECOMMENDED = 'UPDATE_RECOMMENDED';



// WEBPACK FOOTER //
// ./src/actions/constants.js